import React from 'react'
import { Avatar, Typography, Card } from './'
import { BsCalendarCheck, BsPersonBoundingBox } from 'react-icons/bs'
import { css, useTheme } from '@emotion/react'
import { distanceFromNow } from '../../utils'
import { MediaQuery } from './Utility'

function CommentCard({ comment }) {
    const theme = useTheme()
    const mainStyle = css`
        max-width: 92vw;
        .card-content {
            p.typography {
                overflow-x: auto;
                overflow-y: hidden;
            }
        }
        ${MediaQuery('md', 'min')} {
            max-width: 42vw;
        }
        ${MediaQuery('lg', 'min')} {   
            max-width: 52vw;
        }
        ${MediaQuery('xl', 'min')} {
            max-width: 92vw;
        }
    `
    return (
        <div css={mainStyle}>
            <Card bordered spacing="md">
                <div className="flex items-center">
                    <Avatar
                        size="small"
                        bgColor="secGray"
                        color="lighterGray"
                        isImg={false}
                        rounded={false}
                    >
                        <BsPersonBoundingBox />
                    </Avatar>
                    <span
                        type="t"
                        css={css`
                            color: ${theme.colors?.info};
                            font-size: ${theme.fontSize?.sm};
                            background-color: ${theme.colors?.lighterGray};
                            padding: 0.1rem 0.5rem;
                            margin-left: 1rem;
                        `}
                    >
                        {comment.username ?? 'ناشناس'}
                    </span>
                    <Avatar
                        size="small"
                        bgColor="secGray"
                        color="lighterGray"
                        isImg={false}
                        rounded={false}
                    >
                        <BsCalendarCheck />
                    </Avatar>
                    <span
                        type="t"
                        css={css`
                                color: ${theme.colors?.darker};
                                font-size: ${theme.fontSize?.sm};
                                background-color: ${theme.colors?.lighterGray};
                                padding: 0.1rem 0.5rem;
                                margin-left: 1rem;
                            `}
                    >
                        {distanceFromNow(
                            comment.created_at
                        )}
                    </span>
                </div>
                <Typography
                    type="p"
                    color="medGray"
                    className="mt-4"
                >
                    {comment.content}
                </Typography>
            </Card>
        </div>
    )
}

export default CommentCard